import styled from 'styled-components'
import { Typography } from '../../../..'
import { Config } from '../../../../../../config'

const { palette } = Config

export const UnderlineCTA = styled(Typography).attrs({
  as: 'span',
  variant: 7,
})`
  display: inline-block;
  text-decoration: underline;
  color: ${palette.primary};
  transition: opacity 0.15s;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
    text-decoration: underline;
  }
`

export const CTA = styled.div.attrs({
  className: 'mt-4 pt-2',
})`
  width: 100%;
  text-align: center;
`

export const Separator = styled.div.attrs({
  className: 'my-4 py-2',
})`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${palette.primary};
  text-transform: lowercase;
  text-align: center;

  ::before {
    content: '';
    height: 0.1rem;
    flex: 1;
    background: ${palette.hint};
  }

  ::after {
    content: '';
    height: 0.1rem;
    flex: 1;
    background: ${palette.hint};
  }
`

export const SeparatorSpan = styled(Typography).attrs({
  className: 'px-3',
  as: 'span',
})`
  background: ${palette.secondary};
`

export const SocialButtonWrapper = styled.div.attrs({
  className: 'mb-4',
})`
  & [data-btn] {
    color: ${palette.primary} !important;
    border-color: ${palette.primary} !important;
  }

  button {
    position: relative;
    width: 100%;
    padding: 0.8rem 3.8rem;
    background-color: ${palette.white};
    color: ${palette.primary};
    border: 0.1rem solid ${palette.primary} !important;
    border-radius: 0.4rem !important;
    font-size: 1.6rem;
    font-weight: 500;
    font-family: inherit !important;
    box-shadow: none !important;
    cursor: pointer;
    text-transform: none;
    opacity: 1;
    &:hover {
      opacity: 0.7;
    }
    > span {
      color: ${palette.primary} !important;
      font-weight: 500 !important;
      font-size: 1.6rem;
      display: block;
      width: 100%;
      position: absolute;
      text-align: center;
      padding: 0 !important;
    }
    svg {
      position: absolute;
      top: 50%;
      left: 1.8rem;
      margin-top: -0.9rem;
      width: 1.8rem;
      height: 1.8rem;
    }
  }
`

export const FooterContainer = styled(Typography).attrs({
  className: 'mt-4 pt-2',
  as: 'div',
  variant: 7,
  color: 'hint',
})`
  text-align: center;
`
